import React, { useState } from "react";

import InputField from "../../component/inputfiled/Inputfiled";
import { apiErrorMessage } from "../../helper/apiError";
import { Form, Formik } from "formik";
import CustomButton from "../../component/button/button";
import {
  Box,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  FormGroup,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import MicrosoftIcon from "@mui/icons-material/Microsoft";
import { clearApiCache } from "../../helper/apiCache";
import { fontSize } from "../../component/theme/fontSize";
import { fontWeight } from "../../component/theme/fontWeight";
import { FontFamily } from "../../component/theme/fontFamily";
import { ThemeColor } from "../../component/theme/color";
import * as Yup from "yup";
import { LoginService } from "../../Redux/service/SettingService";
import { showSnackbar } from "../../Redux/action/SnackbarAction";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Login from "./Login.page";
import { saveRoles } from "../../Redux/action/SettingAction";
import { GetMicrosoftAuthCodeService } from "../../Redux/service/MailService";

function LoginModule() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [inputValue, setInputValue] = useState("");

  // Microsoft (Office 365) connect prompt shown after a successful login.
  const [msConnectDialog, setMsConnectDialog] = useState({
    open: false,
    url: "",
  });

  // Hard redirect on purpose: the router builds a completely different route
  // table once a token exists, and that table has no "/" route. A client-side
  // navigate would still run inside the logged-out table (landing on "/" and
  // rendering nothing), so reload straight into the target URL instead.
  const goToApp = () => {
    window.location.replace("/CAE/SettingDashboard");
  };

  const handleSkipMicrosoft = () => {
    window.sessionStorage.setItem("ms_auth_skipped", "true");
    setMsConnectDialog({ open: false, url: "" });
    goToApp();
  };

  const handleInputChange = (event) => {
    setInputValue(event.target.value);
  };
  const handleClick = () => {
    alert("Button clicked!");
  };
  const loginSchema = Yup.object({
    email: Yup.string()
      .strict()
      // .lowercase("Email should be in lowercase.")
      .email("Invalid email address")
      .required("Email is required"),
    password: Yup.string()
      .min(6, "Password must be at least 6 characters")
      .required("Password is required"),
  });
  return (
    <Login>
      {" "}
      <div className="main-container-content d-flex flex-column justify-content-center">
        <Typography
          fontSize={fontSize.h2.medium}
          fontWeight={fontWeight.W700}
          fontFamily={FontFamily.Nunito}
        >
          Login
        </Typography>
        <Typography
          fontSize={fontSize.h3.medium}
          fontWeight={fontWeight.W500}
          fontFamily={FontFamily.Nunito}
          className="pb-4"
        >
          Welcome back to Apply CAE 
        </Typography>
        <Formik
          initialValues={{
            email: "",
            password: "",
          }}
          onSubmit={async (values, { setSubmitting }) => {
            LoginService(values)
              .then((res) => {
                if (res.status === 200) {
                  // //("res of login", res);
                  //(res);
                  dispatch(showSnackbar(res.data.message, "success"));
                  console.log(res.data);
                  if (res.data?.user?.isPasswordChanged) {
                    // Fresh session: never reuse anything a previous user left
                    // behind in this tab.
                    clearApiCache();
                    window.sessionStorage.setItem("user_token", res.data.token);
                    window.sessionStorage.setItem("user_id", res.data.user._id);
                    window.sessionStorage.setItem(
                      "user_name",
                      res.data.user.firstName
                    );

                    window.sessionStorage.setItem(
                      "user_email",
                      res.data.user.email
                    );

                    window.sessionStorage.setItem(
                      "user_role_type",
                      res.data?.user?.roleType
                    );

                    if (res.data?.user?.roleType === "agent" || res.data?.user?.roleType === "user") {
                      window.sessionStorage.setItem(
                        "role",
                        res.data?.user?.roles?.role
                      );
                    }

                    if (res.data?.user?.organization) {
                      const orgId =
                        res.data.user.organization?._id ||
                        res.data.user.organization;
                      window.sessionStorage.setItem(
                        "user_organization",
                        orgId.toString()
                      );
                      if (res.data.user.organization?.organizationName) {
                        window.sessionStorage.setItem(
                          "user_organization_name",
                          res.data.user.organization.organizationName
                        );
                      }
                    }

                    if (res.data?.user?.branch) {
                      const branchId =
                        res.data.user.branch?._id || res.data.user.branch;
                      window.sessionStorage.setItem(
                        "user_branch",
                        branchId.toString()
                      );
                    }

                    //(window.sessionStorage.getItem("user_token"));

                    if (res.data?.user?.roles) {
                      //(res.data?.user?.roles, "role roles");

                      dispatch(saveRoles(res.data?.user?.roles));
                    }

                    if (window.sessionStorage.getItem("user_token")) {
                      if (res.data?.user?.roleType === "agent") {
                        goToApp();
                      } else if (res.data?.microsoftAccessToken) {
                        window.sessionStorage.setItem("ms_auth", res.data.microsoftAccessToken);
                        goToApp();
                      } else {
                        window.sessionStorage.removeItem("ms_auth"); // Clear any stale/expired token
                        GetMicrosoftAuthCodeService()
                          .then((authres) => {
                            if (
                              authres.status === 200 &&
                              authres.data?.AuthorizationURL
                            ) {
                              // Ask first: the user can connect now (same tab) or
                              // skip and use the app without the email service.
                              setMsConnectDialog({
                                open: true,
                                url: authres.data.AuthorizationURL,
                              });
                            } else {
                              goToApp();
                            }
                          })
                          .catch((err) => {
                            console.error("Microsoft auth service error: ", err);
                            goToApp();
                          });
                      }
                    }

                    // navigate("/CAE/SettingDashboard");
                    // navigate(0);
                  } else {
                    window.sessionStorage.setItem(
                      "user_first_token",
                      res.data.token
                    );

                    navigate("/changepassword");
                  }
                }
              })
              .catch((e) => {
                dispatch(showSnackbar(e.response?.data?.message, "error"));

                // //("error", apiErrorMessage(e));
              });
          }}
          validationSchema={loginSchema}
        >
          {({
            values,
            errors,
            handleBlur,
            handleChange,
            touched,
            handleSubmit,
          }) => (
            <Form className="">
              <FormGroup style={{}}>
                <InputField
                  // label="Your Name"
                  value={values.email}
                  onChange={handleChange}
                  placeholder="Enter your username / email"
                  fullWidth={true}
                  name={"email"}
                  helperText={
                    <Typography
                      className="px-3"
                      color={ThemeColor.RED}
                      fontSize={fontSize.h4.medium}
                      fontFamily={FontFamily.Lato}
                      fontWeight={fontWeight.W500}
                    >
                      {errors.email}
                    </Typography>
                  }
                />
                <InputField
                  // label="Your Name"
                  value={values.password}
                  onChange={handleChange}
                  type="password"
                  placeholder="Password"
                  fullWidth={true}
                  name={"password"}
                  helperText={
                    <Typography
                      className="px-3"
                      color={ThemeColor.RED}
                      fontSize={fontSize.h4.medium}
                      fontFamily={FontFamily.Lato}
                      fontWeight={fontWeight.W500}
                    >
                      {errors.password}
                    </Typography>
                  }
                />
                <div className="loginform-password-conten">
                  {/* <div>
               <RadioGroup
                 row
                 aria-labelledby="demo-form-control-label-placement"
                 name="position"
                 defaultValue="top"
               >
                 <FormControlLabel
                   value="end"
                   control={<Radio />}
                   label="Remember me"
                   sx={{
                     "& .MuiFormControlLabel-label": {
                       fontSize: fontSize.h3.small,
                       fontWeight: fontWeight.W600,
                       fontFamily: FontFamily.Nunito,
                     },
                   }}
                 />
               </RadioGroup>
             </div> */}
                  <Typography
                    sx={{ textDecoration: "underline", pt: 1, cursor: 'pointer' }}
                    fontFamily={FontFamily.Nunito}
                    fontSize={fontSize.h3.small}
                    fontWeight={fontWeight.W600}
                    onClick={() => navigate('/forgot')}
                  >
                    Forgot Password?
                  </Typography>
                </div>
                <div className="d-flex justify-content-center mt-4">
                  <CustomButton
                    variant="contained"
                    backgroundColor={ThemeColor.LIGHTBLUE}
                    color={ThemeColor.NAVYBLUE}
                    type={"submit"}
                  >
                    Login
                  </CustomButton>
                </div>
              </FormGroup>
            </Form>
          )}
        </Formik>
      </div>

      <Dialog
        open={msConnectDialog.open}
        onClose={handleSkipMicrosoft}
        fullWidth
        maxWidth="xs"
        slotProps={{
          paper: { sx: { borderRadius: "16px", p: { xs: 1, sm: 1.5 } } },
        }}
      >
        <DialogTitle sx={{ pb: 1 }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
            <Box
              sx={{
                width: 40,
                height: 40,
                borderRadius: "10px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: ThemeColor.LIGHTBLUE,
                color: ThemeColor.BLUE,
              }}
            >
              <MicrosoftIcon />
            </Box>
            <Typography
              fontFamily={FontFamily.Nunito}
              fontSize={fontSize.h3.large}
              fontWeight={fontWeight.W700}
            >
              Connect Microsoft account
            </Typography>
          </Box>
        </DialogTitle>

        <DialogContent sx={{ pb: 1 }}>
          <Typography
            fontFamily={FontFamily.Nunito}
            fontSize={fontSize.h3.small}
            sx={{ color: "#667085" }}
          >
            Connect your Office 365 account to send and receive emails from the
            CRM. You can skip this and connect later from the Email menu in the
            sidebar &mdash; until then the email service stays disabled.
          </Typography>
        </DialogContent>

        <DialogActions
          sx={{
            px: 3,
            pb: 2,
            gap: 1.5,
            flexDirection: { xs: "column-reverse", sm: "row" },
            "& .MuiButton-root": { width: { xs: "100%", sm: "auto" } },
          }}
        >
          <CustomButton
            variant="outlined"
            color={ThemeColor.NAVYBLUE}
            type="button"
            onClick={handleSkipMicrosoft}
          >
            Skip for now
          </CustomButton>
          <CustomButton
            variant="contained"
            backgroundColor={ThemeColor.PURPLE}
            color={ThemeColor.WHITE}
            type="button"
            onClick={() => {
              window.location.href = msConnectDialog.url;
            }}
          >
            Connect account
          </CustomButton>
        </DialogActions>
      </Dialog>
    </Login>
  );
}

export default LoginModule;
